<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h1>Are you lost?</h1>
                <p>We couldn't find the page you requested. Pleas use the menu to navigate somewhere</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/404page.vue